import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

import { createShouldForwardProp } from 'helpers/shouldForwardProp';

import LoadingSpinner from '../loading/nestedSpinner';
// components
import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';

const shouldForwardProps = createShouldForwardProp(['horizontalView']);
interface FormulaStatProps {
    messageCount: number;
    error?: string;
    className?: string;
    text: string;
    tooltipText?: string;
    isLoading?: boolean;
    horizontalView: boolean;
}

const FormulaStat: React.FC<React.PropsWithChildren<FormulaStatProps>> = ({
    messageCount,
    error,
    className,
    text,
    tooltipText,
    isLoading,
    horizontalView = false,
}) => {
    return (
        <AampeTooltip title={tooltipText} arrow>
            <Container className={className} horizontalView={!!horizontalView}>
                {isLoading ? (
                    <LoadingSpinner
                        style={{
                            justifyContent: 'start',
                            height: aampeTheme.spacing4(8),
                        }}
                    />
                ) : (
                    <Number>{messageCount?.toLocaleString() || '-'}</Number>
                )}
                <Text>{error || text}</Text>
            </Container>
        </AampeTooltip>
    );
};

export default FormulaStat;

const Container = styled.div.withConfig({
    shouldForwardProp: shouldForwardProps,
})<{ horizontalView: boolean }>(({ horizontalView }) => ({
    display: 'flex',
    flexDirection: horizontalView ? 'row' : 'column',
    gap: aampeTheme.spacing4(2),
    alignItems: horizontalView ? 'end' : '',
}));

const Number = styled.span({
    fontWeight: aampeTheme.weights.heavy,
    fontSize: '28px',
    lineHeight: aampeTheme.size.lineHeight.default,
    color: aampeTheme.colors.textAccessibleWG02,
});

const Text = styled.span({
    color: aampeTheme.colors.textAccessibleWG02,
    fontSize: aampeTheme.size.font.default,
    lineHeight: aampeTheme.size.lineHeight.small,
    fontWeight: aampeTheme.weights.medium,
});
